import api from "../helpers/api";

class YearService{

      
    async create_year(data) {
        
        return await api.post(`/years`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    async update_year(data) {
        
        return await api.put(`/years/${data.id}`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async get_years(page = 1){
        return await api.get(`years?page=${page}`).then(
            response => {
                return response.data
            }
        )
    }

    async search_year(query) {
        try {
            const response = await api.get(`/year/search`, {
            params: { q: query },
            });
            return response.data;
        } catch (error) {
            console.error("Error searching year:", error);
            throw error;
        }
    }

   
    async get_year(id){
        return await api.get(`year/${id}`).then(
            response => {
                return response.data
            }
        )}

    async delete_year(id){
        return await api.delete(`year/${id}`).then(
            response => {
                return response.data
            }
        )}
    
    //get 
    async fetch_totals(){
        return await api.get(`charts/dashboard-totals`).then(
            response => {
                return response.data
            }
        )
    }
    //get 
    async actions_by_company(year_id = 1){
        return await api.get(`charts/actions-by-company/${year_id}`).then(
            response => {
                return response.data
            }
        )
    }
    //get 
    async actions_by_industries(year_id = 1){
        return await api.get(`charts/actions-by-industry/${year_id}`).then(
            response => {
                return response.data
            }
        )
    }


    
   
}
export default new YearService;